































































import axios from 'axios';
import debounce from 'debounce';
import EventBus from '@/eventBus';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';

export default {
    name: 'SetupDomain',
    components: {
        CoButton,
        CoFormGroup,
        CoHeadline,
        CoInput,
    },

    data() {
        return {
            loading: false,
            space: null,

            newDomain: '',
            currentDomain: '',
            isDomainFree: null,
            isDomainValid: true,
            checkingAvailability: false,

            cancelTokenSource: null,
            pad: 0,
        };
    },
    computed: {
        validationHint() {
            if (this.isDomainValid && this.isDomainFree) {
                return '';
            }
            if (!this.isDomainValid) {
                return this.$t('messages.invaliddomain');
            }
            if (this.isDomainValid && this.isDomainFree === false) {
                return this.$t('messages.domainalreadytaken');
            }
            return '';
        },
    },
    created() {
        this.getSpaceSettings();
    },
    methods: {
        handleCustomWebAddressAction() {
            if (this.$store?.state?.limits?.Config?.vanity_domain) {
                if (this.$intercom) {
                    this.$intercom.show();
                } else {
                    this.openHelpCenter();
                }
            } else {
                this.showCustomWebAddressPaywall();
            }
        },
        handleDomainState() {
            this.isDomainFree = null;
            this.isDomainValid = true;

            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel('Previous request aborted due to a new request.');
            }
            this.cancelTokenSource = axios.CancelToken.source();

            this.domainState();
        },
        domainState: debounce(function domainStateCheck() {
            this.checkingAvailability = true;

            if (/^[a-zA-Z0-9](?!.*--)[a-zA-Z0-9-]{1,61}[a-zA-Z0-9]$/.test(`${this.newDomain}`) === false) {
                this.pad += 1;
                this.checkingAvailability = false;
                this.isDomainValid = false;
                this.isDomainFree = false;
                return;
            }
            this.isDomainValid = true;

            const subdomain = this.newDomain;
            if (subdomain === this.currentDomain) {
                this.checkingAvailability = false;
                this.isDomainFree = null;
            } else if (subdomain === '' || subdomain === null || subdomain === undefined || subdomain.includes(' ')) {
                this.checkingAvailability = false;
                this.isDomainFree = false;
            } else {
                this.isDomainFree = null;
                this.checkingAvailability = true;

                this.pad += 1; // pad makes sure that only latest call matter
                const { pad } = this;
                axios({
                    cancelToken: this.cancelTokenSource.token,
                    method: 'GET',
                    url: `/admin/space/is-domain-free?subdomain=${subdomain}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then(() => {
                        if (pad === this.pad) {
                            this.checkingAvailability = false;
                            this.isDomainFree = true;
                        }
                    })
                    .catch((error) => {
                        if (!axios.isCancel(error) && pad === this.pad) {
                            this.checkingAvailability = false;
                            this.isDomainFree = false;
                        }
                    });
            }
        }, 300),
        openHelpCenter() {
            window.open('https://help.coapp.io', '_blank');
        },
        showCustomWebAddressPaywall() {
            EventBus.$emit('PAYWALL', {
                feature: 'branded-domain',
            });
        },
        handleSubmit() {
            this.$refs.inputDomain.blur();
            this.loading = true;
            const data = JSON.stringify({ Subdomain: this.newDomain });

            this.isDomainFree = null;

            axios({
                method: 'POST',
                url: '/admin/space/new-built-in-domain',
                withCredentials: true,
                data,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    this.currentDomain = this.newDomain;
                    if (response && response.data) {
                        const msg = {
                            Message: 'Built-in domain updated',
                            Details: '',
                        };
                        EventBus.$emit('INFO', msg);
                    }
                })
                .catch(() => {
                    this.loading = false;
                    const msg = {
                        Message: 'Failed to change built-in domain',
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                });
        },
        getSpaceSettings() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/admin/space/settings',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    if (response && response.data) {
                        this.space = response.data;
                        if (this.space.DomainName.includes('.')) {
                            const [subdomain] = this.space.DomainName.split('.');
                            this.newDomain = subdomain;
                        } else {
                            this.newDomain = this.space.DomainName;
                        }
                        this.currentDomain = this.newDomain;
                    }
                })
                .catch(() => {
                    this.loading = false;
                    const msg = {
                        Message: 'Failed to get space settings',
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                });
        },
    },
};
